import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { deepEqual } from './../../utils';

import './styles.css';

class DriverCell extends Component {
  shouldComponentUpdate(nextProps) {
    return !deepEqual(this.props, nextProps);
  }

  render() {
    const { driver } = this.props;
    return (
      <div className="driver-row">
        <div
          className="avatar"
          style={{ backgroundImage: `url(${driver.facePicture || '/img/profile-placeholder.png'})` }}
        />
        <div className="info-wrapper">
          <div className="principal">
            {driver.firstName || 'SEM MOTORISTA'}
            {driver.nickname && `, ${driver.nickname}`}
          </div>
          <div className="secondary">
            <small>{driver.surname}</small>
          </div>
          <div className="secondary">
            <small>{driver.homeAddress}</small>
          </div>
        </div>
      </div>
    );
  }
}

DriverCell.propTypes = {
  driver: PropTypes.object.isRequired,
};

export default DriverCell;



// WEBPACK FOOTER //
// ./src/Driver/DriverCell/index.js